export const SAVE_PARAMETER_SUCCESS = 'SAVE_PARAMETER_SUCCESS'
export const SAVE_PARAMETERCONTENT_SUCCESS = 'SAVE_PARAMETERCONTENT_SUCCESS'

export const SAVE_THEME_SUCCESS = 'SAVE_THEME_SUCCESS'
export const SAVE_SELECTED_THEME_SUCCESS = 'SAVE_SELECTED_THEME_SUCCESS'
export const SAVE_MAXID_SUCCESS = 'SAVE_MAXID_SUCCESS'

export const SAVE_AUTH_ISAUTH_SUCCESS = 'SAVE_AUTH_ISAUTH_SUCCESS'
export const SAVE_AUTH_ACCOUNT_SUCCESS = 'SAVE_AUTH_ACCOUNT_SUCCESS'
export const SAVE_AUTH_PROFILE_SUCCESS = 'SAVE_AUTH_PROFILE_SUCCESS'
export const SAVE_AUTH_APITOKEN_SUCCESS = 'SAVE_AUTH_APITOKEN_SUCCESS'

export const URL_GET_FILTERVALUE_PARAMETERS = '/parameters'
export const URL_GET_FILTERVALUE_SEALS = '/filtervalueseals'
export const URL_GET_FILTERVALUE_SUPPLIERS = '/filtervaluesuppliers'
export const URL_GET_FILTERVALUE_SUPPLIERIDS = '/filtervaluesupplierids'
export const URL_GET_FILTERVALUE_INVOICES = '/filtervalueinvoices'
export const URL_GET_FILTERVALUE_INVOICELINES = '/filtervalueinvoicelines'
export const URL_GET_FILTERVALUE_INVOICELINEDETAILS = '/filtervalueinvoicelinedetails'
export const URL_GET_FILTERVALUE_VERUMDBIS = '/filtervalueverumdbis'
export const URL_GET_FILTERVALUE_VERUMPKGS = '/filtervalueverumpkgs'
export const URL_GET_FILTERVALUE_VERUMSTORAGES = '/filtervalueverumstorages'
export const URL_GET_FILTERVALUE_VERUMS = '/filtervalueverums'
export const URL_GET_FILTERVALUE_RBS = '/filtervaluerbs'

export const URL_GET_TOTALBYACCOUNTS = '/totalbyaccounts'
export const URL_GET_SUPPLIERS = '/suppliers'
export const URL_GET_AUDITLOGS = '/auditlogs'
export const URL_GET_ACCOUNTS = '/accounts'
export const URL_GET_BUDGETS = '/budgets'
export const URL_GET_XRFBUDGETPSFLINES = '/xrfbudgetpsflines'
export const URL_GET_SAVE_XRFBUDGETPSFLINES = '/xrfbudgetpsflines'
export const URL_GET_BUDGETCONSUMPTIONS = '/budgetconsumptions'
export const URL_GET_SUPPLIERCONSUMPTIONS = '/supplierconsumptions'
export const URL_GET_RECLASSIFYS = '/reclassifys'
export const URL_GET_PDFS = '/pdfs'
export const URL_GET_INVOICES = '/invoices'
export const URL_GET_INVOICELINES = '/invoicelines'
export const URL_GET_INVOICELINEDETAILS = '/invoicelinedetails'
export const URL_GET_FILELOADINGS = '/fileloadings'
export const URL_GET_FILEEXPORTS = '/fileexports'
export const URL_GET_BUDGETLINES = '/budgetlines'
export const URL_GET_BUDGETLINEDETAILS = '/budgetlinedetails'
export const URL_GET_BUDGETREQUESTS = '/budgetrequests'
export const URL_GET_BUDGETREQUESTEXTRAS = '/budgetrequestextras'
export const URL_GET_GLACCOUNTS = '/glaccounts'
export const URL_GET_CAS = '/cas'
export const URL_GET_PROJECTS = '/projects'
export const URL_GET_PROJECTREPORTINGS = '/projectreportings'
export const URL_GET_ORDERS = '/orders'
export const URL_GET_PSFS = '/psfs'
export const URL_GET_PSFLINES = '/psflines'

export const URL_GET_FILTERVALUE_SLAS = '/filtervalueslas'
export const URL_GET_FILTERVALUE_MODULES = '/filtervaluemodules'
export const URL_GET_FILTERVALUE_DFS = '/filtervaluedfs'
export const URL_GET_FILTERVALUE_DFTYPES = '/filtervaluedftypes'
export const URL_GET_FILTERVALUE_RD1S = '/filtervaluerd1s'
export const URL_GET_FILTERVALUE_SERVICETYPES = '/filtervalueservicetypes'
export const URL_GET_FILTERVALUE_FLAGS = '/filtervalueflags'
export const URL_GET_FILTERVALUE_YEARS = '/filtervalueyears'
export const URL_GET_FILTERVALUE_RD2S = '/filtervaluerd2s'
export const URL_GET_FILTERVALUE_PROJECTLEADERS = '/filtervalueprojectleaders'
export const URL_GET_FILTERVALUE_BUDGETREFS = '/filtervaluebudgetrefs'
export const URL_GET_FILTERVALUE_BUDGETTYPES = '/filtervaluebudgettypes'
export const URL_GET_FILTERVALUE_INVOICETYPES = '/filtervalueinvoicetypes'
export const URL_GET_FILTERVALUE_CADOMAINS = '/filtervaluecadomains'
export const URL_GET_FILTERVALUE_CAIDS = '/filtervaluecaids'
export const URL_GET_FILTERVALUE_CDSTATUSS = '/filtervaluecdstatuss' // TODO IS THIS USED ??
export const URL_GET_FILTERVALUE_ACCOUNTTYPES = '/filtervalueaccounttypes'
export const URL_GET_FILTERVALUE_BEALS = '/filtervaluebeals'
export const URL_GET_FILTERVALUE_TEAMS = '/filtervalueteams'
export const URL_GET_FILTERVALUE_HEADOFDIVISIONS = '/filtervalueheadofdivisions' // TODO IS THIS USED ??

export const URL_GET_BEALTREE = "/bealtree"
export const URL_GET_SEALTREE = "/sealtree"
export const URL_GET_VERUMTREE = "/verumtree"
export const URL_GET_ACCOUNTTREE = "/accounttree"
export const URL_GET_BUDGETTREE = "/budgettree"
export const URL_GET_XRFBUDGETPSFLINETREE = "/xrfbudgetpsflinetree"
export const URL_GET_RECLASSIFYTREE = "/reclassifytree"
export const URL_GET_TOTALBYACCOUNTTREE = "/totalbyaccounttree"
export const URL_GET_SUPPLIERTREE = "/suppliertree"
export const URL_GET_AUDITLOGTREE = "/auditlogtree"
export const URL_GET_INVOICETREE = "/invoicetree"
export const URL_GET_INVOICELINETREE = "/invoicelinetree"
export const URL_GET_INVOICELINEDETAILTREE = "/invoicelinedetailtree"


export const URL_GET_APPLICATION_STATS = '/application/stats'

export const REQUEST_APPLICATION_STATS = 'REQUEST_APPLICATION_STATS'

export const SAVE_SELECTED_GRID_ROW_SUCCESS = 'SAVE_SELECTED_GRID_ROW_SUCCESS'

export const SAVE_USER_SUCCESS = 'SAVE_USER_SUCCESS'
export const BEGIN_AJAX_CALL = 'BEGIN_AJAX_CALL'
export const RESET_AJAX_CALL = 'RESET_AJAX_CALL'
export const END_AJAX_CALL = 'END_AJAX_CALL'

export const AJAX_CALL_ERROR = 'AJAX_CALL_ERROR'
export const SAVE_BEALIDS_SUCCESS = 'SAVE_BEALIDS_SUCCESS'
export const SAVE_SEALIDS_SUCCESS = 'SAVE_SEALIDS_SUCCESS'
export const SAVE_BUDGETREFS_SUCCESS = 'SAVE_BUDGETREFS_SUCCESS'
export const SAVE_BUDGETTYPES_SUCCESS = 'SAVE_BUDGETTYPES_SUCCESS'
export const SAVE_INVOICETYPES_SUCCESS = 'SAVE_INVOICETYPES_SUCCESS'
export const SAVE_CADOMAINS_SUCCESS = 'SAVE_CADOMAINS_SUCCESS'
export const SAVE_CAIDS_SUCCESS = 'SAVE_CAIDS_SUCCESS'
export const SAVE_CDSTATUSS_SUCCESS = 'SAVE_CDSTATUSS_SUCCESS'
export const SAVE_ACCOUNTTYPES_SUCCESS = 'SAVE_ACCOUNTTYPES_SUCCESS'
export const SAVE_RBS_SUCCESS = 'SAVE_RBS_SUCCESS'
export const SAVE_HEADOFDIVISIONS_SUCCESS = 'SAVE_HEADOFDIVISIONS_SUCCESS'
export const SAVE_SERVICETYPES_SUCCESS = 'SAVE_SERVICETYPES_SUCCESS'
export const SAVE_RD1S_SUCCESS = 'SAVE_RD1S_SUCCESS'
export const SAVE_FLAGS_SUCCESS = 'SAVE_FLAGS_SUCCESS'
export const SAVE_YEARS_SUCCESS = 'SAVE_YEARS_SUCCESS'
export const SAVE_RD2S_SUCCESS = 'SAVE_RD2S_SUCCESS'
export const SAVE_PROJECTLEADERS_SUCCESS = 'SAVE_PROJECTLEADERS_SUCCESS'
export const SAVE_SLAIDS_SUCCESS = 'SAVE_SLAIDS_SUCCESS'
export const SAVE_SEALS_SUCCESS = 'SAVE_SEALS_SUCCESS'
export const SAVE_SUPPLIERS_SUCCESS = 'SAVE_SUPPLIERS_SUCCESS'
export const SAVE_SUPPLIERIDS_SUCCESS = 'SAVE_SUPPLIERIDS_SUCCESS'
export const SAVE_SLAS_SUCCESS = 'SAVE_SLAS_SUCCESS'
export const SAVE_MODULES_SUCCESS = 'SAVE_MODULES_SUCCESS'
export const SAVE_DFS_SUCCESS = 'SAVE_DFS_SUCCESS'
export const SAVE_DFTYPES_SUCCESS = 'SAVE_DFTYPES_SUCCESS'
export const SAVE_RD2_SUCCESS = 'SAVE_RD2_SUCCESS'
export const SAVE_FILTERSEARCHTEXT_SUCCESS = 'SAVE_FILTERSEARCHTEXT_SUCCESS'

export const SAVE_SELECTED_HEADOFDIVISIONS_SUCCESS = 'SAVE_SELECTED_HEADOFDIVISIONS_SUCCESS'
export const SAVE_SELECTED_BUDGETREFS_SUCCESS = 'SAVE_SELECTED_BUDGETREFS_SUCCESS'
export const SAVE_SELECTED_BUDGETTYPES_SUCCESS = 'SAVE_SELECTED_BUDGETTYPES_SUCCESS'
export const SAVE_SELECTED_INVOICETYPES_SUCCESS = 'SAVE_SELECTED_INVOICETYPES_SUCCESS'
export const SAVE_SELECTED_CADOMAINS_SUCCESS = 'SAVE_SELECTED_CADOMAINS_SUCCESS'
export const SAVE_SELECTED_CAIDS_SUCCESS = 'SAVE_SELECTED_CAIDS_SUCCESS'
export const SAVE_SELECTED_CDSTATUSS_SUCCESS = 'SAVE_SELECTED_CDSTATUSS_SUCCESS'
export const SAVE_SELECTED_ACCOUNTTYPES_SUCCESS = 'SAVE_SELECTED_ACCOUNTTYPES_SUCCESS'
export const SAVE_SELECTED_BEALIDS_SUCCESS = 'SAVE_SELECTED_BEALIDS_SUCCESS'
export const SAVE_SELECTED_SEALIDS_SUCCESS = 'SAVE_SELECTED_SEALIDS_SUCCESS'
export const SAVE_SELECTED_SLAIDS_SUCCESS = 'SAVE_SELECTED_SLAIDS_SUCCESS'
export const SAVE_SELECTED_DFS_SUCCESS = 'SAVE_SELECTED_DFS_SUCCESS'
export const SAVE_SELECTED_DFTYPES_SUCCESS = 'SAVE_SELECTED_DFTYPES_SUCCESS'
export const SAVE_SELECTED_SERVICETYPES_SUCCESS = 'SAVE_SELECTED_SERVICETYPES_SUCCESS'
export const SAVE_SELECTED_RD1S_SUCCESS = 'SAVE_SELECTED_RD1S_SUCCESS'
export const SAVE_SELECTED_FLAGS_SUCCESS = 'SAVE_SELECTED_FLAGS_SUCCESS'
export const SAVE_SELECTED_YEARS_SUCCESS = 'SAVE_SELECTED_YEARS_SUCCESS'
export const SAVE_SELECTED_RD2S_SUCCESS = 'SAVE_SELECTED_RD2S_SUCCESS'
export const SAVE_SELECTED_PROJECTLEADERS_SUCCESS = 'SAVE_SELECTED_PROJECTLEADERS_SUCCESS'
export const SAVE_SELECTED_YEAR_SUCCESS = 'SAVE_SELECTED_YEAR_SUCCESS'
export const SAVE_SELECTED_ROLE_SUCCESS = 'SAVE_SELECTED_ROLE_SUCCESS'
export const SAVE_SELECTED_SUPPLIERIDS_SUCCESS = 'SAVE_SELECTED_SUPPLIERIDS_SUCCESS'
export const SAVE_SELECTED_SUPPLIERS_SUCCESS = 'SAVE_SELECTED_SUPPLIERS_SUCCESS'
export const SAVE_SELECTED_RBS_SUCCESS = 'SAVE_SELECTED_RBS_SUCCESS'
export const SAVE_SELECTED_BUDGETS_SUCCESS = 'SAVE_SELECTED_BUDGETS_SUCCESS'

export const SAVE_FILTERSDATA_SUCCESS = 'SAVE_FILTERSDATA_SUCCESS'

export const SAVE_SUBSCRIPTION_ID_SUCCESS = 'SAVE_SUBSCRIPTION_ID_SUCCESS'
export const SAVE_SUBSCRIPTION_IDS_SUCCESS = 'SAVE_SUBSCRIPTION_IDS_SUCCESS'

export const SAVE_LOCALE_SUCCESS = 'SAVE_LOCALE_SUCCESS'
export const SAVE_LOCALES_SUCCESS = 'SAVE_LOCALES_SUCCESS'

export const SAVE_YEAR_SUCCESS = 'SAVE_YEAR_SUCCESS'

export const SAVE_ROLE_SUCCESS = 'SAVE_ROLE_SUCCESS'
export const SAVE_ROLES_SUCCESS = 'SAVE_ROLES_SUCCESS'

export const SAVE_TEST_SUCCESS = 'SAVE_TEST_SUCCESS'
export const SAVE_TESTCONTENT_SUCCESS = 'SAVE_TESTCONTENT_SUCCESS'

export const SAVE_TEAM_SUCCESS = 'SAVE_TEAM_SUCCESS'
export const SAVE_TEAMCONTENT_SUCCESS = 'SAVE_TEAMCONTENT_SUCCESS'

export const SAVE_PROJECTLEADER_SUCCESS = 'SAVE_PROJECTLEADER_SUCCESS'
export const SAVE_PROJECTLEADERCONTENT_SUCCESS = 'SAVE_PROJECTLEADERCONTENT_SUCCESS'

export const SAVE_CONTRACT_SUCCESS = 'SAVE_CONTRACT_SUCCESS'
export const SAVE_CONTRACTCONTENT_SUCCESS = 'SAVE_CONTRACTCONTENT_SUCCESS'

export const SAVE_ORDER_SUCCESS = 'SAVE_ORDER_SUCCESS'
export const SAVE_ORDERCONTENT_SUCCESS = 'SAVE_ORDERCONTENT_SUCCESS'

export const SAVE_PSF_SUCCESS = 'SAVE_PSF_SUCCESS'
export const SAVE_PSFCONTENT_SUCCESS = 'SAVE_PSFCONTENT_SUCCESS'

export const SAVE_PSFLINE_SUCCESS = 'SAVE_PSFLINE_SUCCESS'
export const SAVE_PSFLINECONTENT_SUCCESS = 'SAVE_PSFLINECONTENT_SUCCESS'

export const SAVE_BUDGET_SUCCESS = 'SAVE_BUDGET_SUCCESS'
export const SAVE_BUDGETCONTENT_SUCCESS = 'SAVE_BUDGETCONTENT_SUCCESS'

export const SAVE_XRFBUDGETPSFLINE_SUCCESS = 'SAVE_XRFBUDGETPSFLINE_SUCCESS'
export const SAVE_XRFBUDGETPSFLINECONTENT_SUCCESS = 'SAVE_XRFBUDGETPSFLINECONTENT_SUCCESS'

export const SAVE_BUDGETCONSUMPTION_SUCCESS = 'SAVE_BUDGETCONSUMPTION_SUCCESS'
export const SAVE_BUDGETCONSUMPTIONCONTENT_SUCCESS = 'SAVE_BUDGETCONSUMPTIONCONTENT_SUCCESS'

export const SAVE_SUPPLIERCONSUMPTION_SUCCESS = 'SAVE_SUPPLIERCONSUMPTION_SUCCESS'
export const SAVE_SUPPLIERCONSUMPTIONCONTENT_SUCCESS = 'SAVE_SUPPLIERCONSUMPTIONCONTENT_SUCCESS'

export const SAVE_RECLASSIFY_SUCCESS = 'SAVE_RECLASSIFY_SUCCESS'
export const SAVE_RECLASSIFYCONTENT_SUCCESS = 'SAVE_RECLASSIFYCONTENT_SUCCESS'

export const SAVE_PDF_SUCCESS = 'SAVE_PDF_SUCCESS'

export const SAVE_ACCOUNT_SUCCESS = 'SAVE_ACCOUNT_SUCCESS'
export const SAVE_ACCOUNTCONTENT_SUCCESS = 'SAVE_ACCOUNTCONTENT_SUCCESS'

export const SAVE_TOTALBYACCOUNT_SUCCESS = 'SAVE_TOTALBYACCOUNT_SUCCESS'
export const SAVE_TOTALBYACCOUNTCONTENT_SUCCESS = 'SAVE_TOTALBYACCOUNTCONTENT_SUCCESS'

export const SAVE_SUPPLIER_SUCCESS = 'SAVE_SUPPLIER_SUCCESS'
export const SAVE_SUPPLIERCONTENT_SUCCESS = 'SAVE_SUPPLIERCONTENT_SUCCESS'

export const SAVE_AUDITLOG_SUCCESS = 'SAVE_AUDITLOG_SUCCESS'
export const SAVE_AUDITLOGCONTENT_SUCCESS = 'SAVE_AUDITLOGCONTENT_SUCCESS'

export const SAVE_BUDGETLINE_SUCCESS = 'SAVE_BUDGETLINE_SUCCESS'
export const SAVE_BUDGETLINECONTENT_SUCCESS = 'SAVE_BUDGETLINECONTENT_SUCCESS'
export const SAVE_BUDGETLINEFORM_SUCCESS = 'SAVE_BUDGETLINEFORM_SUCCESS'

export const SAVE_BUDGETLINEDETAIL_SUCCESS = 'SAVE_BUDGETLINEDETAIL_SUCCESS'
export const SAVE_BUDGETLINEDETAILCONTENT_SUCCESS = 'SAVE_BUDGETLINEDETAILCONTENT_SUCCESS'
export const SAVE_BUDGETLINEDETAILFORM_SUCCESS = 'SAVE_BUDGETLINEDETAILFORM_SUCCESS'

export const SAVE_BUDGETREQUEST_SUCCESS = 'SAVE_BUDGETREQUEST_SUCCESS'
export const SAVE_BUDGETREQUESTCONTENT_SUCCESS = 'SAVE_BUDGETREQUESTCONTENT_SUCCESS'
export const SAVE_BUDGETREQUESTEXTRA_SUCCESS = 'SAVE_BUDGETREQUESTEXTRA_SUCCESS'
export const SAVE_BUDGETREQUESTEXTRACONTENT_SUCCESS = 'SAVE_BUDGETREQUESTEXTRACONTENT_SUCCESS'

export const SAVE_GLACCOUNT_SUCCESS = 'SAVE_GLACCOUNT_SUCCESS'
export const SAVE_GLACCOUNTCONTENT_SUCCESS = 'SAVE_GLACCOUNTCONTENT_SUCCESS'

export const SAVE_CA_SUCCESS = 'SAVE_CA_SUCCESS'
export const SAVE_CACONTENT_SUCCESS = 'SAVE_CACONTENT_SUCCESS'

export const SAVE_PROJECT_SUCCESS = 'SAVE_PROJECT_SUCCESS'
export const SAVE_PROJECTREPORTING_SUCCESS = 'SAVE_PROJECTREPORTING_SUCCESS'

export const SAVE_PROJECTCONTENT_SUCCESS = 'SAVE_PROJECTCONTENT_SUCCESS'
export const SAVE_PROJECTREPORTINGCONTENT_SUCCESS = 'SAVE_PROJECTREPORTINGCONTENT_SUCCESS'

export const SAVE_INVOICE_SUCCESS = 'SAVE_INVOICE_SUCCESS'
export const SAVE_INVOICEREFS_SUCCESS = 'SAVE_INVOICEREFS_SUCCESS'
export const SAVE_SELECTED_INVOICEREFS_SUCCESS = 'SAVE_SELECTED_INVOICEREFS_SUCCESS'
export const SAVE_INVOICECONTENT_SUCCESS = 'SAVE_INVOICECONTENT_SUCCESS'

export const SAVE_INVOICELINE_SUCCESS = 'SAVE_INVOICELINE_SUCCESS'
export const SAVE_INVOICELINEDETAIL_SUCCESS = 'SAVE_INVOICELINEDETAIL_SUCCESS'

export const SAVE_INVOICELINECONTENT_SUCCESS = 'SAVE_INVOICELINECONTENT_SUCCESS'
export const SAVE_INVOICELINEDETAILCONTENT_SUCCESS = 'SAVE_INVOICELINEDETAILCONTENT_SUCCESS'

export const SAVE_FILELOADING_SUCCESS = 'SAVE_FILELOADING_SUCCESS'
export const SAVE_FILELOADINGCONTENT_SUCCESS = 'SAVE_FILELOADINGCONTENT_SUCCESS'
export const SAVE_FILEEXPORT_SUCCESS = 'SAVE_FILEEXPORT_SUCCESS'
export const SAVE_FILEEXPORTCONTENT_SUCCESS = 'SAVE_FILEEXPORTCONTENT_SUCCESS'

export const SAVE_SERVICETYPE_SUCCESS = 'SAVE_SERVICETYPE_SUCCESS'
export const SAVE_SERVICETYPECONTENT_SUCCESS = 'SAVE_SERVICETYPECONTENT_SUCCESS'

export const SAVE_BUSINESS_SUCCESS = 'SAVE_BUSINESS_SUCCESS'
export const SAVE_BUSINESSCONTENT_SUCCESS = 'SAVE_BUSINESSCONTENT_SUCCESS'

export const SAVE_ROLECONTENT_SUCCESS = 'SAVE_ROLECONTENT_SUCCESS'

export const SAVE_GROUP_SUCCESS = 'SAVE_GROUP_SUCCESS'
export const SAVE_GROUPCONTENT_SUCCESS = 'SAVE_GROUPCONTENT_SUCCESS'
export const SAVE_USERCONTENT_SUCCESS = 'SAVE_USERCONTENT_SUCCESS'

export const SAVE_INTEGRATION_JOB_DATA = 'SAVE_INTEGRATION_JOB_DATA'
export const SAVE_INTEGRATION_JOB_CONTENT = 'SAVE_INTEGRATION_JOB_CONTENT'

export const SAVE_SELECTED_FEATURES_SUCCESS = 'FEATURES' // FEATURES | FEATURES_PREVIEW


export const SAVE_SLA_SUCCESS = 'SAVE_SLA_SUCCESS'
export const SAVE_SLACONTENT_SUCCESS = 'SAVE_SLACONTENT_SUCCESS'

export const SAVE_MODULE_SUCCESS = 'SAVE_MODULE_SUCCESS'
export const SAVE_MODULECONTENT_SUCCESS = 'SAVE_MODULECONTENT_SUCCESS'

export const SAVE_APPLICATION_SUCCESS = 'SAVE_APPLICATION_SUCCESS'
export const SAVE_APPLICATIONCONTENT_SUCCESS = 'SAVE_APPLICATIONCONTENT_SUCCESS'

export const SAVE_VERUM_SUCCESS = 'SAVE_VERUM_SUCCESS'
export const SAVE_VERUMDBI_SUCCESS = 'SAVE_VERUMDBI_SUCCESS'
export const SAVE_VERUMPKG_SUCCESS = 'SAVE_VERUMPKG_SUCCESS'
export const SAVE_VERUMBCM_SUCCESS = 'SAVE_VERUMBCM_SUCCESS'
export const SAVE_VERUMSTORAGE_SUCCESS = 'SAVE_VERUMSTORAGE_SUCCESS'
export const SAVE_VERUMMIDDLEWARE_SUCCESS = 'SAVE_VERUMMIDDLEWARE_SUCCESS'
export const SAVE_VERUMCONTENT_SUCCESS = 'SAVE_VERUMCONTENT_SUCCESS'
export const SAVE_VERUMPKGCONTENT_SUCCESS = 'SAVE_VERUMPKGCONTENT_SUCCESS'
export const SAVE_VERUMSTORAGECONTENT_SUCCESS = 'SAVE_VERUMSTORAGECONTENT_SUCCESS'
export const SAVE_VERUMDBICONTENT_SUCCESS = 'SAVE_VERUMDBICONTENT_SUCCESS'


export const SAVE_BCM_SUCCESS = 'SAVE_BCM_SUCCESS'
export const SAVE_BCMCONTENT_SUCCESS = 'SAVE_BCMCONTENT_SUCCESS'

export const URL_GET_APPROVALREQUESTS = '/approvalrequests'

export const SAVE_APPROVALREQUEST_SUCCESS = 'SAVE_APPROVALREQUEST_SUCCESS'
export const SAVE_APPROVALREQUESTCONTENT_SUCCESS = 'SAVE_APPROVALREQUESTCONTENT_SUCCESS'

export const SAVE_SUPPLIERREFS_SUCCESS = 'SAVE_SUPPLIERREFS_SUCCESS'
export const SAVE_SELECTED_SUPPLIERREFS_SUCCESS = 'SAVE_SELECTED_SUPPLIERREFS_SUCCESS'
export const URL_GET_FILTERVALUE_SUPPLIERREFS = '/filtervaluesupplierrefs'

export const SAVE_SUPPLIERTYPES_SUCCESS = 'SAVE_SUPPLIERTYPES_SUCCESS'
export const SAVE_SELECTED_SUPPLIERTYPES_SUCCESS = 'SAVE_SELECTED_SUPPLIERTYPES_SUCCESS'
export const URL_GET_FILTERVALUE_SUPPLIERTYPES = '/filtervaluesuppliertypes'
